module.exports = __webpack_public_path__ + "static/media/tnpa-mission.f085f4b6.png";